import { render, staticRenderFns } from "./idCardVerification.vue?vue&type=template&id=5988f9ad&scoped=true"
import script from "./idCardVerification.vue?vue&type=script&lang=js"
export * from "./idCardVerification.vue?vue&type=script&lang=js"
import style0 from "./idCardVerification.vue?vue&type=style&index=0&id=5988f9ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988f9ad",
  null
  
)

export default component.exports